import { CheckCircleSVG } from 'common/assets';
import { ActionContainer } from 'components/styles';
import isEmpty from 'lodash/isEmpty';
import useTranslation from 'next-translate/useTranslation';
import * as React from 'react';
import { useFormContext } from 'react-hook-form';

import { Button } from '../buttons';
import { ButtonProps } from '../buttons/button';
import { FormContext } from '../form';

export interface SubmitProps extends ButtonProps {
  text?: string;
  hideIcon?: boolean;
  type: 'submit';
  rightIcon?: React.ReactNode;
}

export default function SubmitField(props: SubmitProps) {
  const { t } = useTranslation();
  const context = React.useContext(FormContext);
  const { formState } = useFormContext();
  const {
    disabled,
    text = t('common:save'),
    hideIcon,
    rightIcon,
    type = 'submit',
    ...restProps
  } = props;

  if (!context.editable && !formState.isSubmitting) {
    return null;
  }

  const isValid = isEmpty(formState.errors);

  return (
    <Button
      disabled={disabled || !isValid || formState.isSubmitting}
      isLoading={formState.isSubmitting}
      type={type}
      {...restProps}
    >
      {!hideIcon && (
        <ActionContainer $style={{ marginRight: '8px', flex: 0 }}>
          <CheckCircleSVG
            size={16}
            color={
              disabled || !isValid || formState.isSubmitting
                ? 'rgb(175, 175, 175)'
                : '#FFFFFF'
            }
          />
        </ActionContainer>
      )}
      {text}
      {rightIcon}
    </Button>
  );
}
